import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as actions from "../actions";
import * as globalActions from "../../../../action/CommonActions";

import {
	driverBookmarksSelector,
	bookMarksFetchingSelector,
	commonSelector
} from "../selectors";

let select = createStructuredSelector({
	bookMarksData: driverBookmarksSelector,
	fetchingBookmarks: bookMarksFetchingSelector,
	common:commonSelector
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(actions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch)
});

export default connect(select, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/dataProvider/index.js